export const setIaAgents = (iaAgents) => ({
    type: "SET_IA_AGENTS",
    payload: iaAgents,
});
